// @ts-nocheck
import React, { useState } from "react";
import { useQuery } from "react-query";
import SendingCont from "components/EditDrawer/SendingCont/SendingCont";
import genRequest from "includes/request";

export default function FilledFormSendStep(props) {
	const [isSended, setIsSended] = useState(false);
	const form = props.object;

	React.useEffect(() => {
		let timer1 = null;
		if (props.isActive && !props.isDone && isSended === true) {
			timer1 = setTimeout(() => {
				props.instance.nextStep();
				props.setIsDone(true);
			}, 1000);
		}
		return () => {
			clearTimeout(timer1);
		}
	}, [props, isSended]);

	if (!props.isActive)
		return (false);

	return (
		<div className="sending-cont">
			<SendAnswers form={form} isSended={isSended} setIsSended={setIsSended} />
		</div>
	);
}

function SendAnswers({ form, isSended, setIsSended }) {
	const [isSending, setIsSending] = useState(false);

	function getAnswers() {
		let answers = [];

		for (let sec of form.sections)
			if (sec.questions?.length)
				for (let quest of sec.questions)
					if (quest.answers?.length)
						for (let ans of quest.answers)
							answers.push(ans.values());
		return (answers);
	}

	function send() {
		let answers = getAnswers();

		if (!answers?.length)
			return (Promise.reject(false));
		setIsSending(true);
		let prom = genRequest(
			"forms/form-answers/multiple",
			answers,
			"post"
		)
		return (prom);
	}

	const req = useQuery(
		["SendAnswer", "Form", form.id, form.lastChanged],
		send,
		{
			enabled: !isSended && !isSending,
			staleTime: 0,
			cacheTime: 0,
			retry: 3,
			onSuccess: () => {
				setIsSended(true);
				setIsSending(false);
			}
		}
	);

	return (
		<SendingCont title={"Envoi des réponses"} {...req} isSended={isSended} />
	);
}
